
import fb from '../../firebase'
import { LayoutsState, RootState } from '../types'
import { moduleActionContext } from '..'
import Axios from 'axios'
import { Layout, SceneTransitionAction } from '@/types/layouts'
import { ActionContext } from 'vuex'

type LayoutsContext = ActionContext<LayoutsState, RootState>

const layoutsModule = {
  namespaced: true,
  state: {} as LayoutsState,
  actions: {
    async addLayout (_context: LayoutsContext, layout: Layout) {
      return await fb.db.collection('layouts').add(layout)
    },
    async deleteLayout (_context: LayoutsContext, layoutId: string) {
      await fb.db.collection('layouts').doc(layoutId).delete()
    },
    async performTransitionAction (_context: LayoutsContext, action: SceneTransitionAction) {
      const url = new URL(action.url)
      const body = JSON.parse(action.body)
      /*
      if (url.hostname.includes('.singular.') && Array.isArray(body)) {
        body.map((composition) => {
          if (delay < 0) return composition
          return composition.timestamp = Date.now() + delay
        })
      } else {
        await sleep(action.offsetDelay)
      }
      */
      const headers = { 'Content-Type': 'application/json', 'Authorization': '' }
      if (action.token) headers.Authorization = `Bearer ${ action.token }`

      switch (action.method) {
        case 'get':
          Axios.get(url.href, { headers })
          break
        case 'put':
          Axios.put(url.href, body, { headers })
          break
        case 'post':
          Axios.post(url.href, body, { headers })
          break
        case 'delete':
          Axios.delete(url.href, { headers })
          break
      }
    }
  },
  mutations: {}
} as const

export default layoutsModule

export const layoutsModuleActionContext = context => moduleActionContext(context, layoutsModule)
